import React from 'react';
import moment from 'moment';
import R from 'ramda';
import { JiraFlatButton } from '../../tc-ui/small-buttons';

const EmailTracking = ({
  recipients,
  rawEvents,
  sentDate,
  showRecipients,
  clickShowRecipients,
  isSender,
  format,
  inLeftNav,
}) => {
  const events = R.omit(
    [R.keys(rawEvents).find(str => str.indexOf('open') > -1)],
    rawEvents
  );
  const blockedType = {
    dropped: true,
    deferred: true,
    bounce: true,
    blocked: true,
  };
  const eventTags = {
    click: 'clicked',
    open: 'opened',
    delivered: 'delivered',
    unsubscribe: 'unsubscribed',
    'spam report': 'spam report',
    bounce: 'bounced',
    deferred: 'deferred',
    dropped: 'dropped',
    processed: 'processed',
    redirected: 'redirected',
  };
  const eventSort = R.reverse(Object.keys(eventTags));
  const emails = recipients.map(({ email }) => email);
  const emailsInEventNotInOriginal = R.values(events)
    .map(e => e.email)
    .filter(str => emails.indexOf(str) === -1);
  const eventToDate = timestamp => {
    if (isNaN(timestamp)) {
      return moment(timestamp).format('D MMM YYYY, H:mm');
    }
    return moment.unix(timestamp).format('D MMM YYYY, H:mm');
  };
  const lastEvents = R.map(
    arrays => {
      return R.sortBy(({ event, timestamp }) => {
        return -1 * ((eventSort.indexOf(event) || 0) + 1) * timestamp;
      }, arrays)[0];
    },
    R.groupBy(
      ({ email }) => email,
      Object.values(events)
        // .filter(({ email }) => emails.indexOf(email) > -1) // we could have events related to other email addresses
        .map(({ email, event, timestamp }) => ({
          email,
          event,
          dateTime: eventToDate(timestamp),
          timestamp,
        }))
    )
  );
  const eventGroup = R.groupBy(({ event }) => event, Object.values(lastEvents));
  const eventSummary = Object.keys(eventGroup).map(
    event => `${eventGroup[event].length} ${eventTags[event]}`
  );
  return (
    <div>
      <div
        style={
          inLeftNav ? { display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }
          : { display: 'flex', alignItems: 'center' }
        }
      >
        <div className={inLeftNav ? '' : 'flex-center'}>
          <div>
            {sentDate ? moment(new Date(sentDate)).format(format || 'MMMM DD, YYYY') : 'NA'}
          </div>
          {eventSummary.length > 0 && (
            <small>
              &nbsp;&nbsp;({
                eventSummary.map((str, i) => (
                  <span
                    key={str}
                    style={{
                      color: R.keys(blockedType).some(type => str.indexOf(type) > -1) ? 'red' : 'inherit',
                    }}
                  >
                    {i ? `, ` : ''}{str}
                  </span>
                ))
              })
            </small>
          )}
        </div> &nbsp;&nbsp;
        {isSender && (
          <JiraFlatButton
            onClick={clickShowRecipients}
            labelStyle={{ fontSize: '10px' }}
            label={`${showRecipients ? 'Hide' : 'Show'} Details`}
          />
        )}
      </div>
      <div
        style={{
          display: showRecipients ? 'block' : 'none',
          backgroundColor: '#fafafa',
          borderRadius: '5px',
          padding: '8px 16px',
          border: '1px solid #e0e0e0',
          marginTop: '4px',
        }}
      >
        {recipients.map(({ email }) => (
          <div key={email}>
            <small>
              <strong>{email}</strong>
              {lastEvents[email] ? (
                <span style={inLeftNav ? { display: 'block' } : {}}>
                  {' '}
                  (email {eventTags[lastEvents[email].event]}
                  &nbsp;on&nbsp;
                  {lastEvents[email].dateTime})
                </span>
              ) : (
                <span style={inLeftNav ? { display: 'block' } : {}}> (email processing)</span>
              )}
            </small>
          </div>
        ))}
        {
          emailsInEventNotInOriginal.map(email => (
            <div
              key={email}
            >
              <small>
                <i>forwarded address</i>
                {lastEvents[email] ? (
                  <span>
                    {' '}
                    (email {eventTags[lastEvents[email].event]}
                    &nbsp;on&nbsp;
                    {lastEvents[email].dateTime})
                  </span>
                ) : (
                  <span style={inLeftNav ? { display: 'block' } : {}}> (notified in system)</span>
                )}
              </small>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default EmailTracking;



// WEBPACK FOOTER //
// ./src/app/components/contracting/comments/email-tracking.jsx